// ======================================================================
// File Name       : ContentLinkSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Form, Col, Button } from 'react-bootstrap';
import { DATA_AFFIILIATION_TYPE_STR } from '../../constants/ContentConstant';
import RenderField from '../../utils/ReduxFormUtils';
import PaginationCustom from '../Pagination';
import { VALIDATE_TYPE } from '../../constants/index';
import ReduxFormPaging from '../ReduxFormPaging';
import CustomButton from '../button/CustomButton';
import CustomLink from '../button/CustomLink';
import * as Path from '../../constants/PathConstants';
import * as ICON from '../../constants/IconConstants';
import * as FUNCTION from '../../constants/FunctionConstants';
import { canAccessRoute } from '../../utils/AuthedUtils';

class ContentLinkSearch extends React.Component {
  render() {
    const { startPosition,
      recordNum,
      onInputChange,
      onSearchBtnClick,
      getStartEndData,
      onExportBtnClick,
    } = this.props;
    const canAccessImport = canAccessRoute(FUNCTION.CONTENT_LINK_IMPORT);
    const canAccessRegister = canAccessRoute(FUNCTION.CONTENT_LINK_REGISTER);

    return (
      <div>
        <h3>検索する項目を指定してください</h3>
        <Col sm={12} className="padding-left-right-clear">
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              onSearchBtnClick();
            }}
            className='form-horizontal'
          >
            <Col sm={12} className="padding-top-10">
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={3}>
                  コンテンツ識別ID
                </Col>
                <Col sm={7}>
                  <RenderField type="text" name="contentSecernId" maxLength="64" validates={[VALIDATE_TYPE.ID]} />
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={3}>
                  コンテンツ名
                </Col>
                <Col sm={7}>
                  <RenderField type="text" name="contentName" maxLength="256" />
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col sm={3} as={Form.Label}>
                  登録日
                </Col>
                <Col sm={3}>
                  <RenderField
                    type="datetime"
                    name="createdDateFrom"
                    validates={[VALIDATE_TYPE.DATE_TIME]}
                    normalizeDateTime
                  />
                </Col>
                <Col sm={1} className="text-center" as={Form.Label}>
                  ～
                </Col>
                <Col sm={3}>
                  <RenderField
                    type="datetime"
                    name="createdDateTo"
                    validates={[VALIDATE_TYPE.DATE_TIME]}
                    normalizeDateTime
                  />
                </Col>
                <Col sm={12}>
                  <RenderField
                    name="dateTimeMinMax"
                    type="dateTimeMinMax"
                    validates={[VALIDATE_TYPE.DATE_TIME_MIN_MAX]}
                    keyDateFrom={'createdDateFrom'}
                    keyDateTo={'createdDateTo'}
                  />
                </Col>
              </Form.Group>
              {/* Step 9.0.0 START */}
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={3}>
                  登録者
                </Col>
                <Col sm={7}>
                  <RenderField type="text" name="createdUserName" maxLength={40} />
                </Col>
              </Form.Group>
              {/* Step 9.0.0 END */}
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={3}>
                  自サービス/外部
                </Col>
                <Col sm={9} className="padding-top-10">
                  <RenderField
                    inline
                    className="padding-top-clear margin-right-3"
                    name="dataAffiliationType"
                    type="radio"
                    value={DATA_AFFIILIATION_TYPE_STR.NOT_SELECT}
                    label="選択なし"
                  />
                  <RenderField
                    inline
                    className="margin-left-15 padding-top-clear"
                    name="dataAffiliationType"
                    type="radio"
                    value={DATA_AFFIILIATION_TYPE_STR.INTERNAL}
                    label="自サービスコンテンツ"
                  />
                  <RenderField
                    inline
                    className="margin-left-15 padding-top-clear"
                    name="dataAffiliationType"
                    type="radio"
                    value={DATA_AFFIILIATION_TYPE_STR.EXTERNAL}
                    label="外部コンテンツ"
                  />
                </Col>
              </Form.Group>
            </Col>
            <Form.Group className="margin-top-20 margin-bottom-20 text-center form-info">
              <Col sm={12} className="text-center">
                <CustomButton
                  btnStyle="btn btn-primary btn-96 margin-top-10"
                  type="submit"
                  text="検索"
                  iconClass="bi bi-search"
                />
              </Col>
            </Form.Group>
            <Form.Group>
              <Col sm={12} className="margin-bottom-15">
                <Col sm={9} className="inline-flex">
                  {canAccessRegister && (
                    <CustomLink
                      className="margin-right-7 btn-register margin-right-10"
                      to={Path.CONTENT_LINK_REGISTER}
                      text="リンク追加"
                      icon={ICON.REGIST}
                    />
                  )}
                  {canAccessImport && (
                    <CustomLink
                      className="margin-right-7 btn-csv-import"
                      to={Path.CONTENT_LINK_IMPORT}
                      text="CSV一括投入"
                      icon={ICON.IMPORT}
                    />
                  )}
                </Col>
                <Col sm={3}>
                  <CustomButton
                    btnStyle="btn btn-export-csv float-end"
                    handleClick={onExportBtnClick}
                    iconClass="bi bi-download"
                    text="一括出力"
                  />
                </Col>
              </Col>
            </Form.Group>
          </Form>
        </Col>
      </div>
    );
  }
}

export default ContentLinkSearch;
